import React from "react";
import { View, StyleSheet } from "react-native";
import { ThemedText } from "@/components/ThemedText";
import { useTheme } from "@/hooks/useTheme";
import Avatar from "@/components/Avatar";
import { InviteStatus } from "./types";
import { ShiftUserType } from "@/types/db/shift_users";
import { getStatusColor } from "./utils";
// import { UserName } from "./UserName";

type StatusGroupProps = {
  status: InviteStatus;
  users: ShiftUserType[];
};

export function StatusGroup({ status, users }: StatusGroupProps) {
  const { colors } = useTheme();
  const statusColor = getStatusColor(status, colors);

  // Don't show empty groups except for ACCEPTED (to show availability)
  if (users.length === 0 && status !== "ACCEPTED") {
    return null;
  }

  return (
    <View style={styles.statusGroup}>
      <View style={styles.statusHeader}>
        <View style={[styles.statusDot, { backgroundColor: statusColor }]} />
        <ThemedText style={styles.statusLabel}>
          {status} ({users.length})
        </ThemedText>
      </View>

      {users.length === 0 ? (
        <ThemedText style={[styles.emptyText, { color: colors.placeholder }]}>(none)</ThemedText>
      ) : (
        <View style={styles.usersList}>
          {users.map((shiftUser) => {
            const userName = shiftUser.user
              ? `${shiftUser.user.preferred_name || shiftUser.user.first_name || ""} ${shiftUser.user.last_name || ""}`.trim() ||
                "Unknown User"
              : "Loading...";

            return (
              <View key={shiftUser.id} style={styles.userRow}>
                <Avatar
                  userId={shiftUser.user?.id ?? ""}
                  firstName={(shiftUser.user?.preferred_name || shiftUser.user?.first_name) ?? ""}
                  lastName={shiftUser.user?.last_name ?? ""}
                  size={24}
                />
                <ThemedText style={styles.userName} numberOfLines={1}>
                  {userName}
                </ThemedText>
              </View>
            );
          })}
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  statusGroup: {
    gap: 6,
  },
  statusHeader: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  statusDot: {
    width: 6,
    height: 6,
    borderRadius: 3,
  },
  statusLabel: {
    fontSize: 11,
    fontWeight: "600",
    textTransform: "uppercase",
    opacity: 0.8,
  },
  emptyText: {
    fontSize: 12,
    fontStyle: "italic",
    paddingLeft: 12,
  },
  usersList: {
    gap: 4,
    paddingLeft: 12,
  },
  userRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  userName: {
    fontSize: 13,
    flex: 1,
  },
});
